import script from "./EventsAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsAdd.vue?vue&type=script&setup=true&lang=js"

import "./EventsAdd.vue?vue&type=style&index=0&id=2725a155&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2725a155"]])

export default __exports__